<template>
  <div class="help-root">

    <div class="help-intro">
      <span class="material-symbols-outlined help-hero-icon">swap_horiz</span>
      <p>
        Gestiona las referencias y derivaciones emitidas: consulta los registros
        de pacientes enviados a otra unidad de salud o especialista, edita los
        detalles y genera el formulario oficial en PDF.
      </p>
    </div>

    <!-- Búsqueda -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">search</span>
        Búsqueda de referencias
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in busquedas" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Columnas de la tabla -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">table_chart</span>
        Información en la tabla
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="col in columnas" :key="col.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ col.icon }}</span>
          <div>
            <p class="help-card-title">{{ col.titulo }}</p>
            <p class="help-card-desc">{{ col.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Opciones por fila -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">touch_app</span>
        Opciones por referencia
      </h3>
      <div class="help-actions">
        <div class="help-action" v-for="a in acciones" :key="a.titulo">
          <span class="material-symbols-outlined help-action-icon" :style="{ color: a.color }">{{ a.icon }}</span>
          <div>
            <p class="help-card-title">{{ a.titulo }}</p>
            <p class="help-card-desc">{{ a.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <div class="help-tip">
      <span class="material-symbols-outlined">lightbulb</span>
      <p>
        Al ingresar se cargan automáticamente todas las referencias de la empresa
        en sesión. Si el campo de búsqueda está vacío al pulsar Buscar, se
        recargan todos los registros.
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: "AyudaReferencia",
  data() {
    return {
      busquedas: [
        {
          icon: "person_search",
          titulo: "Por nombre",
          desc:   "Escribe el nombre del paciente y presiona Enter o el botón Buscar para filtrar las referencias.",
        },
        {
          icon: "auto_awesome_motion",
          titulo: "Todos los registros",
          desc:   "Pulsa el botón de lista para recargar todas las referencias de la empresa sin aplicar filtros.",
        },
      ],
      columnas: [
        {
          icon:   "calendar_today",
          titulo: "Fecha Ref.",
          desc:   "Fecha en la que fue emitida la referencia o derivación.",
        },
        {
          icon:   "schedule",
          titulo: "Hora",
          desc:   "Hora registrada al momento de emitir la referencia.",
        },
        {
          icon:   "person",
          titulo: "Nombre",
          desc:   "Nombre completo del paciente referido.",
        },
        {
          icon:   "category",
          titulo: "Tipo",
          desc:   "Indica si el registro es una Referencia (envío a otra unidad) o una Derivación (envío a otra especialidad dentro de la misma unidad).",
        },
        {
          icon:   "label",
          titulo: "Motivo",
          desc:   "Motivo clínico por el cual se emite la referencia o derivación.",
        },
      ],
      acciones: [
        {
          icon:   "summarize",
          color:  "#0059cc",
          titulo: "Editar",
          desc:   "Muestra el resumen completo de la referencia: empresa de origen y destino, médico, paciente, hallazgos, tratamiento y justificación.",
        },
        {
          icon:   "edit_note",
          color:  "#198754",
          titulo: "Detalles",
          desc:   "Abre el formulario de edición para modificar los datos de la referencia o derivación.",
        },
        {
          icon:   "picture_as_pdf",
          color:  "#dc3545",
          titulo: "Formulario informe",
          desc:   "Genera y descarga en PDF el formulario oficial de referencia/derivación (Formulario 007) para su impresión o archivo.",
        },
      ],
    };
  },
};
</script>

<style src="@/assets/css/ayuda.css" scoped></style>